<template>
    <div>
        <card>
            <h3>Component test</h3>
            <b-container fluid class="bv-example-row">
                <b-row>
                    <b-col xl="3">
                        <AnnouncementImage v-bind:id=941 />
                    </b-col>
                    <b-col xl="3">
                        <AnnouncementImage v-bind:id=942 />
                    </b-col>
                </b-row>
            </b-container>
        </card>
    </div>
</template>

<script>
import AnnouncementImage from '@/components/Announcements/AnnouncementImage.vue'

export default {
    components: {
        AnnouncementImage
    }
    
}
</script>